import React from 'react';
import { Chip } from '@mui/material';
import { Roles } from '../models/roles';

export const chatRoles = {
  volunteer: 'Volunteer',
  foodDonor: 'Food Donor',
  receivingAgency: 'Receiving Agency',
  siteCoordinator: 'Site Coordinator',
  siteDirector: 'Site Director',
};

export const getRoleColors = (role) => {
  switch (role) {
    case chatRoles.volunteer:
      return { light: '#e1eee4', dark: '#4c7554' };
    case chatRoles.foodDonor:
      return { light: '#f1dec1', dark: '#a28255' };
    case chatRoles.receivingAgency:
      return { light: '#daefef', dark: '#4f7777' };
    case chatRoles.siteCoordinator:
      return { light: '#eae5f6', dark: '#625b99' };
    case chatRoles.siteDirector:
      return { light: '#dfe9f9', dark: '#4d608d' };
    default:
      return { light: '#e1eee4', dark: '#4c7554' };
  }
};

export const renderUserRoleChip = (role) => {
  if (!role) {
    return null;
  }

  const roleColors = getRoleColors(role);
  return (
    <Chip
      key={role}
      label={role}
      size="small"
      sx={{
        height: '16px',
        bgcolor: roleColors.light,
        color: roleColors.dark,
        '& .MuiChip-label': {
          fontSize: 10,
          fontWeight: 700,
          textTransform: 'uppercase',
        },
      }}
    />
  );
};

export const getChatRoles = (roles = [], isSiteStaff = false) => {
  const userChatRoles = [];
  if (!roles.length) {
    return userChatRoles;
  }

  // Site staff
  if (roles.includes(Roles.SiteDirector) || roles.includes(Roles.SiteCoordinator)) {
    if (roles.includes(Roles.SiteDirector)) {
      userChatRoles.push(chatRoles.siteDirector);
    } else {
      userChatRoles.push(chatRoles.siteCoordinator);
    }
  }

  // Show only staff role for site staff members
  if (isSiteStaff) {
    return userChatRoles;
  }

  // Food Donor
  if (
    roles.includes(Roles.DonorAdmin) ||
    roles.includes(Roles.DonorStaff) ||
    roles.includes(Roles.DonorLocationAdmin) ||
    roles.includes(Roles.DonorLocationStaff)
  ) {
    userChatRoles.push(chatRoles.foodDonor);
  }

  // Receiver
  if (
    roles.includes(Roles.ReceiverAdmin) ||
    roles.includes(Roles.ReceiverStaff) ||
    roles.includes(Roles.ReceiverLocationAdmin) ||
    roles.includes(Roles.ReceiverLocationStaff)
  ) {
    userChatRoles.push(chatRoles.receivingAgency);
  }

  // Rescuer
  if (roles.includes(Roles.Rescuer)) {
    userChatRoles.push(chatRoles.volunteer);
  }

  return userChatRoles;
};

export const getChatTitles = (roleAssigments = []) => {
  const userChatTitles = [];
  if (!roleAssigments?.length) {
    return userChatTitles;
  }

  // Food Donor
  const donor = roleAssigments.find(
    (assignment) =>
      assignment?.role_name === Roles.DonorAdmin ||
      assignment?.role_name === Roles.DonorStaff ||
      assignment?.role_name === Roles.DonorLocationAdmin ||
      assignment?.role_name === Roles.DonorLocationStaff
  );

  if (donor?.donor_location_name) {
    userChatTitles.push(donor.donor_location_name);
  }

  const receiver = roleAssigments.find(
    (assignment) =>
      assignment?.role_name === Roles.ReceiverAdmin ||
      assignment?.role_name === Roles.ReceiverStaff ||
      assignment?.role_name === Roles.ReceiverLocationAdmin ||
      assignment?.role_name === Roles.ReceiverLocationStaff
  );

  if (receiver?.receiver_name) {
    userChatTitles.push(receiver.receiver_name);
  }

  return userChatTitles;
};
